"use client";

import React, { createContext, type ReactNode, useContext } from "react";

export type T_WorkspaceUserIdentity = {
  firstName: string | null;
};

const DEFAULT_WORKSPACE_USER: T_WorkspaceUserIdentity = {
  firstName: null,
};

const WorkspaceUserContext = createContext<T_WorkspaceUserIdentity>(
  DEFAULT_WORKSPACE_USER,
);

export function WorkspaceUserProvider({
  children,
  firstName,
}: {
  children: ReactNode;
  firstName: string | null;
}) {
  return (
    <WorkspaceUserContext.Provider value={{ firstName }}>
      {children}
    </WorkspaceUserContext.Provider>
  );
}

export function useWorkspaceUser(): T_WorkspaceUserIdentity {
  return useContext(WorkspaceUserContext);
}
